import { CurrencyRupeeIcon } from "@heroicons/react/24/outline";
import { UseMutateFunction, useMutation, useQuery } from "@tanstack/react-query";
import { CreateCommanWay, GetCommanWay, ListCommanWay } from "API/commonApi";
import axios, { AxiosResponse } from "axios";
import { Button, Img, Input } from "components";
import moment from "moment";
import React, { useEffect, useState } from "react";
import QRCode from "react-qr-code";
import { useNavigate, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import UseToast from "utils/AfToast";
import { roles } from "utils/constant";
import { get_file_url } from "utils/lib-utils";

declare global {
  interface Window {
    SEND_WAPP: (num: any, link: any, msg: any) => void;
  }
}
//const pickupStatusCodes = [0, 1, 2, 4, 5];
const pickupStatusCodes = ["Pickup Processed", "Pickup Done", "Pickup Cancel", "Pickup Reschedule", "Confirmed"];
const TrackingPickup = () => {
  const BASE_URL = process.env.REACT_APP_BACKEND_URL;
  const navigator = useNavigate();

  const [pickupCode, setPickupCode] = useState("");
  const [pickupTrackingData, setPickupTrackingData] = useState<any>({
    tracking_data: [],
    awbData: {},
    pickupData: {},
  });
  const [searchParams, setSearchParams] = useSearchParams();
  const [deliveryDoneInfo, setDeliveryDoneInfo] = useState<any>({});
  const [productList, setProductList] = useState<any>([]);

  const [showImg, setShowImg] = useState<any>(false);
  const [showVolume, setShowVolume] = useState<any>(false);

  const [userRole, setUserRole] = useState<string>("");

  const [wappNo, setWappNo] = useState<any>("");
  const SEND_WAPP = (num: any, link: any, msg: any) => {
    let pdfPath = BASE_URL;
    if (pickupTrackingData?.pickupData?.customer_code) {
      pdfPath += "/invoices_c";
    } else {
      pdfPath += "/invoices";
    }
    pdfPath += `/${pickupTrackingData?.awbData?._invoice_no_c_b?.subbranch}/${pickupTrackingData?.awbData?._invoice_no_c_b?.invoice_no}.pdf`;
    axios.request({
      url: BASE_URL + `/admin/send-wapp`,
      method: "POST",
      data: {
        mobile: num,
        pdf: pdfPath,
        msg: msg,
      },
    });
    setWappNo("");
    alert("Whatsapp Sent Successfully!");
  };

  React.useEffect(() => {
    const userD = localStorage.getItem("auth") ? JSON.parse(localStorage.getItem("auth")) : {};
    if (Object.keys(userD).length) {
      setUserRole(userD.state.user.roleName);
      if (userD.state.user.roleName == "CUSTOMER") {
        navigator("/");
      }
    }
  }, []);

  useQuery(["admin_product_list"], () => ListCommanWay("/admin/product/list", {}, {}), {
    keepPreviousData: true,
    onSuccess(data) {
      if (data.status == "SUCCESS") {
        setProductList(data.data.data);
      }
    },
    onError: (data) => {},
  });

  const {
    mutate,
    isLoading: isloading,
  }: {
    mutate: UseMutateFunction<AxiosResponse<any, any>, unknown, any, unknown>;
    isLoading: any;
  } = useMutation((pickup_code) => GetCommanWay("/admin/pickup_pod/track/" + pickup_code, {}, {}), {
    onSuccess: (data: any) => {
      console.log(data, data.status == "SUCCESS");
      if (data.status == "SUCCESS") {
        setPickupTrackingData(data.data);
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
    },
  });

  useEffect(() => {
    if (searchParams.get("awb")) {
      setPickupCode(searchParams.get("awb"));
      setPickupTrackingData({
        tracking_data: [],
        awbData: {},
        pickupData: {},
      });
      mutate(searchParams.get("awb"));
    }
  }, [searchParams]);

  const getTRline = (name, value, isEven: any = false) => {
    return (
      <tr className={isEven ? "bg-blue-100" : ""}>
        <td className="text-right pr-5 whitespace-nowrap">{name}</td>
        <td>{value}</td>
      </tr>
    );
  };

  const getChargeableWeight = (weight, product_code, ll, bb, hh) => {
    ll = Number(ll);
    bb = Number(bb);
    hh = Number(hh);
    let dWeight = (ll * bb * hh) / (product_code == "X" ? 2700 : 5000);
    return Math.max(Number(weight), dWeight);
  };

  return (
    <>
      <div className="flex flex-col gap-4 px-4 mt-2 font-inter">
        <div className=" border p-2 rounded-2xl">
          <div>
            <h1 className="text-center mb-2 text-lg font-semibold underline whitespace-nowrap">Pickup Details:</h1>
          </div>
          <div className="flex gap-2">
            <table className="">
              <tr className={true ? "bg-blue-100" : ""}>
                <td className="text-right pr-5 pb-0.5 whitespace-nowrap">Reference No</td>
                <td>
                  <h1 className="text-blue-800 font-semibold bg-yellow-200 inline-block px-2 pt-0.5 rounded-md">{pickupCode}</h1>
                </td>
              </tr>

              {getTRline(
                "Date",
                pickupTrackingData.pickupData?.pickup_date_time ||
                  moment(pickupTrackingData.pickupData?.date).format("DD-MM-YYYY HH:mm:ss"),
                0
              )}
              {getTRline("Product", pickupTrackingData.pickupData?.product_name, 1)}
              {getTRline(
                "City",
                <div className="text-center flex items-center gap-4">
                  <span>
                    {pickupTrackingData.pickupData.shipper_city}
                    <br />
                    {pickupTrackingData.pickupData.shipper_pincode}
                  </span>
                  <span className="text-4xl"> → </span>
                  <span>
                    {pickupTrackingData.pickupData.consignee_city}
                    <br />
                    {pickupTrackingData.pickupData.consignee_pincode}
                  </span>
                </div>
              )}
              {getTRline("Client Name", pickupTrackingData.pickupData.customer_sh + ` (${pickupTrackingData.pickupData.customer_code})`, 1)}
              {getTRline("Shipper Name", <b>{pickupTrackingData.pickupData.shipper_sh}</b>, 0)}
              {getTRline("Shipper Addr", pickupTrackingData.pickupData.shipper_address, 0)}
              {getTRline("Consignee Name", <b>{pickupTrackingData.pickupData.consignee_cgnee}</b>, 1)}
              {getTRline("Consignee Addr", pickupTrackingData.pickupData.consignee_address, 1)}
            </table>

            <div className="mx-4">
              <table className={`flex-1 items-center w-auto justify-center border-b-2 font-inter`}>
                <tr className="border-y-2 text-left text-blue-800">
                  <th className="px-4 border-x">Date time</th>
                  <th className="px-4 border-x">Status</th>
                  <th className="px-4 border-x">Employee</th>
                </tr>
                <tr className="">
                  <td className="px-2 border-x whitespace-nowrap">
                    {pickupTrackingData.pickupData?.createdAt || "-"}
                  </td>
                  <td className="px-2 border-x whitespace-nowrap">Pickup Register</td>
                  <td className="px-2 border-x">
                    {pickupTrackingData.pickupData?._addedBy?.name || "-"}
                  </td>
                </tr>
                {pickupTrackingData.tracking_data.length ?
                  [...pickupTrackingData.tracking_data]
                    .sort((a, b) => a.id - b.id)
                    .map((d, i) => (
                      <>
                        <tr className="" key={`track-data${d.id}`}>
                          <td className="px-2 border-x whitespace-nowrap">
                            {moment(d.updatedAt).format("DD-MM-YYYY") == "Invalid date"
                              ? d.updatedAt
                              : moment(d.updatedAt, "DD-MM-YYYY HH:mm").format("DD-MM-YYYY HH:mm")}
                          </td>
                          <td className="px-2 border-x">{pickupStatusCodes[d.status]}</td>
                          <td className="px-2 border-x">{d._addedBy ? d._addedBy.name : "-"}</td>
                        </tr>
                      </>
                    )):""}
              </table>
            </div>
          </div>
          <div className="flex justify-between mt-2 border-t pt-2">
            <div className="flex gap-8 flex-1">
              {pickupTrackingData.awbData.realWeight && (
                <p>
                  Actual Weight: <b>{pickupTrackingData.awbData.realWeight} kg</b>
                </p>
              )}
              <p>
                Product Type: <b>{pickupTrackingData.pickupData.type}</b>
              </p>
              <p>
                10_30: <b>{pickupTrackingData.pickupData.ten_30 ? "YES" : "NO"}</b>
              </p>
              <p>
                Holiday: <b>{pickupTrackingData.pickupData.holiday ? "YES" : "NO"}</b>
              </p>
            </div>
          </div>
        </div>

        {showImg && (
          <div className="flex gap-4">
            {pickupTrackingData.tracking_data[pickupTrackingData.tracking_data.length - 1]?.signature && (
              <Img
                className="h-48"
                src={get_file_url(pickupTrackingData.tracking_data[pickupTrackingData.tracking_data.length - 1]?.signature)}
              />
            )}
            {pickupTrackingData.tracking_data[pickupTrackingData.tracking_data.length - 1]?.photo && (
              <Img
                className="h-48"
                src={get_file_url(pickupTrackingData.tracking_data[pickupTrackingData.tracking_data.length - 1]?.photo)}
              />
            )}
          </div>
        )}

        <div className="flex gap-2 flex-wrap border p-2 rounded-2xl pb-8">
          <div className="w-full font-bold underline ">AWB Details</div>
          <table className={`flex-1 items-center w-auto justify-center`}>
            <tr className="border-y-2 text-left text-blue-800">
              <th>Sr</th>
              <th>AWB No</th>
              <th>Weight</th>
              <th>Motherbag</th>
              <th>Status</th>
              <th>Status Time</th>
            </tr>
            {pickupTrackingData.awbData.length &&
              [...pickupTrackingData.awbData].map((d, i) => (
                <>
                  <tr className="" key={`awbData-data${d.id}`}>
                    <td>{i + 1}</td>
                    <td>
                      <a target="_blank" className="text-blue-500 py-1 font-semibold" href={`/pod/tracking?awb=${d.awb_no}`}>
                        {d.awb_no}
                      </a>
                    </td>
                    <td>{d.a_weight || d.realWeight}</td>
                    <td>{d.mother_bag_code}</td>
                    <td>{d.pod_message}</td>
                    <td>{moment(d.pod_updatedAt).format("DD/MM/YYYY HH:mm")}</td>
                  </tr>
                </>
              ))}
          </table>
        </div>
      </div>
    </>
  );
};

export default TrackingPickup;
